import React, { useContext, useState, useEffect, useRef } from "react";
import ComponentNotificationBulb from "../../shared-components/notification-bulb/index";
import ComponentAvatar from "../../shared-components/avatar/index";
import ContextOffcanvas from "../../contexts/offcanvas-context";
import "./_index.scss";
import {
  BannerImageHandlingForAllDevices,
  isFreeUser,
} from "../../components/utility/ReUsableFunctions";
import InfiniteScroll from "react-infinite-scroll-component";
import ContextUser from "./../../contexts/user-context";

import { useDispatch, useSelector } from "react-redux";
// Replace custom icon imports with Lucide React icons
import { 
  Menu, 
  Infinity, 
  Trophy, 
  Target, 
  Users, 
  Mail, 
  Bell 
} from "lucide-react";
import {
  Button,
  Card,
  Container,
  Dropdown,
  FormControl,
  ListGroup,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import Notification from "../../components/Notification/Notification";
import {
  fetchMoreNotifications,
  getNotifications,
  markReadNotification,
  markAllNotificationsAsRead,
} from "../../actions/Notification/NotificationActions";
import { getMyMessages, getMemberInvitations, getPendingInvitations } from "../../actions/CommunityActions/CommunityAction";
import axios from "axios";
import { URL as API_URL } from "../../api/tklEnvironments";
import ComponentAvtar from "../../components/CourseCreation/modals/ComponentAvatar";
import { useHistory } from "react-router-dom";
import ButterflyMark from "../../shared-components/page-loader/butterflyMark";

const style = {
  a: {
    width: '48px',
    padding: '10px 0 0',
    position: 'relative',
    display: 'block'
  },
  bubleContainer: {
    position: 'absolute',
    top: '-1px',
    left: '12px'
  },
  amountContainer: {
    position: 'absolute',
    top: '2px',
    left: '17px',
    color: '#FFF',
    fontSize: '10px'
  }
};

function useOutsideAlerter(ref, dropDownShow, setDropDownShow) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        // let tempDropShow = dropDownShow;
        // setDropDownShow(!tempDropShow);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

const ComponentSiteheader = React.memo(function ComponentSiteheader(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  const wrapperRef = useRef(null);

  const { notification, notification_reload } = useSelector(
    (state) => state.notifications
  );
  const { listOfMessages, memberInvitations, pendingInvitations } = useSelector((state) => state.community);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [currentNotification, setCurrentNotification] = useState([]);
  const [dropDownShow, setDropDownShow] = useState(false);
  useOutsideAlerter(wrapperRef, dropDownShow, setDropDownShow);
  const [pageCount, setPageCount] = useState(1);
  const [hasMoreNotfications, setHasMoreNotfications] = useState(true);
  const [notificationCount, setNotificationCount] = useState(true);
  const userData = useSelector((state) => state.users.userData);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      const next = window.innerWidth < 768;
      setIsMobile((prev) => (prev === next ? prev : next));
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggle = () => setPopoverOpen(!popoverOpen);
  const toggleOffcanvas = useContext(ContextOffcanvas);
  const toggleSiteNav = props.toggleSiteNav;

  // const { userProfileData } = useContext(ContextUser);

  const openSiteNav = () => {
    if (toggleSiteNav) {
      toggleSiteNav(true);
    }
  };
  const openUserNav = () => {
    if (toggleOffcanvas) {
      toggleOffcanvas(true, "OffcanvasUserAccount", "");
    }
  };

  // Fetch notifications on initial load
  React.useEffect(() => {
    if (localStorage.getItem("token") && !userData?.firstName) {
      dispatch(getNotifications());
    }
  }, [dispatch, userData?.firstName]);

  // Initialize messages data and member invitations and set up polling
  React.useEffect(() => {
    if (localStorage.getItem("token")) {
      dispatch(getMyMessages());
      dispatch(getMemberInvitations(null, 1, "", true));
      dispatch(getPendingInvitations(null, 1, "", true));

      const pollingInterval = setInterval(() => {
        dispatch(getMyMessages());
        dispatch(getMemberInvitations(null, 1, "", true));
        dispatch(getPendingInvitations(null, 1, "", true));
      }, 10 * 60 * 1000);

      return () => clearInterval(pollingInterval);
    }
  }, [dispatch]);

  // React.useMemo(() => {
  //   //console.log("notification", notification);
  // }, [notification]);

  React.useEffect(() => {
    setCurrentNotification(Array.isArray(notification?.data) ? notification.data : []);
  }, [JSON.stringify(notification)]);

  React.useEffect(() => {
    dispatch(getNotifications());
  }, [notification_reload]);

  React.useEffect(() => {
    //console.log("currentNotification ", currentNotification);
  }, [currentNotification]);

  // Mark all notifications as read when dropdown opens
  React.useEffect(() => {
    if (dropDownShow && currentNotification?.length > 0) {
      const unreadCount = currentNotification.filter(n => n?.read_at === null).length;
      if (unreadCount > 0) {
        console.log('📬 Marking all notifications as read...', 'Unread count:', unreadCount);
        dispatch(markAllNotificationsAsRead());
      }
    }
  }, [dropDownShow]);

  const fetchMoreNotfctn = () => {
    let tempPageCount = pageCount;
    
    console.log('📄 Fetching notifications - Current page:', tempPageCount, 'Next page:', tempPageCount + 1);
    
    axios
      .get(`${API_URL}/notification?page=${tempPageCount + 1}`)
      .then(function (response) {
        if (response.data) {
          const oldArray = currentNotification || [];
          const newArray = response?.data?.data || [];
          const combinedArray = [...oldArray, ...newArray];

          console.log('📊 Loaded page:', response.data?.current_page, 'Last page:', response.data?.last_page);
          console.log('📦 Old array length:', oldArray.length, 'New array length:', newArray.length, 'Combined:', combinedArray.length);

          // Check if we should stop loading MORE
          const isLastPage = response.data?.current_page === response.data?.last_page;
          const hasNoNewData = newArray.length === 0;
          const reachedPageLimit = tempPageCount + 1 >= 3;
          const shouldStop = isLastPage || hasNoNewData || reachedPageLimit;
          
          console.log('🛑 Should stop?', shouldStop, '- Last page:', isLastPage, '- No new data:', hasNoNewData, '- Page limit:', reachedPageLimit);

          setCurrentNotification(combinedArray);
          setPageCount(tempPageCount + 1);

          // Stop immediately if no more data, otherwise use small delay for smoother UX
          if (shouldStop) {
            if (hasNoNewData) {
              // Stop immediately if no data returned
              setHasMoreNotfications(false);
            } else {
              // Small delay for smoother transition when there IS data
              setTimeout(() => {
                setHasMoreNotfications(false);
              }, 300);
            }
          }
        }
      })
      .catch(function (error) {
        console.error("Error fetching more notifications:", error);
        // Stop loading if there's an error to prevent infinite spinner
        setHasMoreNotfications(false);
      });
  };

  const getCurrentNotificationLength = () => {
    let notificationLength = currentNotification?.filter(
      (notObject) => notObject?.read_at === null
    )?.length;
    //console.log("notificationLength", notificationLength);
    return notificationLength;
  };

  const getTotalMessages = () => 
    listOfMessages?.data?.reduce((acc, item) => acc + (item?.totalMessages || 0), 0) || 0;

  const getPendingInvitesCount = () => 
    memberInvitations?.meta?.total || 0;

  const handleOnClickNotification = (item) => {
    const prevValue = dropDownShow;
    console.log("...item", item);

    if (item?.data?.cohortDiscussionData) {
      let {
        cohortDisplayId,
        commentIdentifier,
        fragmentSlug,
        parentCommentIdentifier,
      } = item?.data?.cohortDiscussionData;
      sessionStorage.setItem("cohortDisplayId", cohortDisplayId);
      sessionStorage.setItem(
        "commentIdentifier",
        parentCommentIdentifier || commentIdentifier
      );
      sessionStorage.setItem("cohortFragmentSlug", fragmentSlug);
      history.push(`/discussionForums/${cohortDisplayId}`);
    }
    if (item?.data?.feedbackData) {
      let {
        cohortId,
        isIntroductionStep,
        cohortModuleIndex,
        cohortSectionIndex,
        stepIndex,
        activitySlug,
        stepSlug,
      } = item?.data?.feedbackData;
      if (isIntroductionStep) {
        history.push(`/cohortIntroduction/cohortActivity/${cohortId}/introduction/1/${stepIndex}/${stepSlug}/cohortUserLearner/true`);
      } else {
        history.push(`/cohortActivity/${cohortId}/${cohortModuleIndex}/${cohortSectionIndex}/${stepIndex}/${activitySlug}/cohortUserLearner/true`);
      }
    }

    if (item?.data?.groupData?.redirectionLink) {
      // Navigate to colleagues page with My Professional Groups tab selected
      window.location.href = `/colleagues?tab=myProfessionalGroup`;
      return;
    }

    // Close the dropdown after navigation
    setDropDownShow(false);

    // Handle new post notifications
    if (item?.data?.type === 'new_post' && item?.data?.data?.post_id) {
      const postId = item?.data?.data?.post_id;
      // Navigate to the-loop with the highlighted post ID as a query parameter
      window.location.href = `/the-loop?highlightPost=${postId}`;
      return;
    }

    // Handle comment notifications
    if (item?.data?.type === 'comment' && item?.data?.data?.post_id) {
      const postId = item?.data?.data?.post_id;
      const commentId = item?.data?.data?.comment_id;
      // Navigate to the-loop with the post ID and comment ID to show and highlight the specific comment
      if (commentId) {
        window.location.href = `/the-loop?highlightPost=${postId}&commentId=${commentId}`;
      } else {
        // Fallback if no comment ID
        window.location.href = `/the-loop?highlightPost=${postId}`;
      }
      return;
    }

    // Handle connection request notifications
    if (item?.data?.type === 'connection_request') {
      // Navigate to colleagues page with Member Invitations tab selected
      window.location.href = `/colleagues?tab=memberInvitations`;
      return;
    }
  };

  const rsStyles = {
    siteHeader: {
      width: '100% !important',
      maxWidth: '100% !important',
      padding: 0,
      margin: 0,
    },
    headerContainer: {
      width: '100%',
      maxHeight: '3em',
      padding: 0,
    },
    logoContainer: {
      display: 'flex',
      alignItems: 'center'
    },
    logoSvg: {
      width: isMobile ? '22px' : '24px',
      height: isMobile ? '22px' : '24px'
    },
    siteLogo: {
      padding: '11px 0 0 8px'
    },
    navIcons: {
      display: 'flex',
      alignItems: 'center',
      gap: isMobile ? '8px' : '12px',
    },
    icons: {
      height: isMobile ? '17px' : '20px',
      width: isMobile ? '20px' : '22px'
    },
    iconLink: {
      ...style.a,
      width: isMobile ? '32px' : '40px',
      padding: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  };

  return (
    <div>
      <div
        className="siteheader-comp notifications position-fixed w-100 top-0 left-0"
        style={{
          ...rsStyles.headerContainer,
          zIndex: 9999, // Ensures it stays above other elements
          backgroundColor: "#fff", // Adds a background to avoid transparency issues
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Optional: Adds a subtle shadow for better visibility
        }}
      >
        <header
          className="d-flex flex-row justify-content-between align-items-center"
          style={rsStyles.headerContainer}
        >
          <div className="d-flex flex-row justify-content-center align-items-center" style={rsStyles.logoContainer}>
            <button
              type="button"
              className="sitenav-toggle border-0 p-0 me-2"
              onClick={openSiteNav}
            >
              <Menu size={isMobile ? 22 : 24} color="#666" />
            </button>
            <a
              href={isFreeUser(userData?.roles) ? "/the-loop" : "/"}
              className="site-logo" style={rsStyles.siteLogo}
            >
              <svg
                style={rsStyles.logoSvg}
                version="1.2"
                baseProfile="tiny"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 202 202"
              >
                <path
                  fill="#1DBAAD"
                  d="M92,92H22C9.9,92,0,82.1,0,70L0,0l24,0c37.4,0,68,30.6,68,68V92z"
                />
                <path
                  fill="#FCB127"
                  d="M180,92h-70V68c0-37.6,30.4-68,68-68h24v70C202,82.2,192.2,92,180,92z"
                />
                <path
                  fill="#DF1C45"
                  d="M47,202h-2c-24.8,0-45-20.3-45-45v-2c0-24.9,20.1-45,45-45h47v47C92,181.9,71.9,202,47,202z"
                />
                <path
                  fill="#3F749C"
                  d="M157,202h-2c-24.8,0-45-20.3-45-45v-47h47c24.9,0,45,20.1,45,45v2C202,181.9,181.9,202,157,202z"
                />
              </svg>
              </a>
          </div>
          <div className="header-nav-icons d-flex flex-row justify-content-start align-items-center" style={rsStyles.navIcons}>
            {userData && localStorage.getItem("token") && (
            <>
              <a href="/the-loop" title="The Loop - Community Posts & Discussions" style={rsStyles.iconLink}>
                <Infinity 
                  size={isMobile ? 18 : 20} 
                  color="#666"
                  style={{ opacity: 0.7 }}
                />
              </a>
              <a href="/rewards" title="Rewards - Points, Badges & Leaderboard" style={rsStyles.iconLink}>
                <Trophy 
                  size={isMobile ? 18 : 20} 
                  color="#666"
                  style={{ opacity: 0.7 }}
                />
              </a>
              <a href="/challenges" title="Challenges - Monthly Activities & Goals" style={rsStyles.iconLink}>
                <Target 
                  size={isMobile ? 18 : 20} 
                  color="#666"
                  style={{ opacity: 0.7 }}
                />
              </a>
              <a href="/colleagues" title="Colleagues - Pending Invitations" style={{...rsStyles.iconLink, position: 'relative'}}>
                <Users 
                  size={isMobile ? 18 : 20} 
                  color="#666"
                  style={{ opacity: 0.7 }}
                />
                {getPendingInvitesCount() > 0 && (
                  <div style={{
                    position: 'absolute',
                    top: '-5px',
                    right: '-5px',
                    minWidth: '16px',
                    height: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <ComponentNotificationBulb count={getPendingInvitesCount()} color="#3F749C" />
                  </div>
                )}
              </a>
              <a href="/colleagues" title="Messages - Direct Communications" style={{...rsStyles.iconLink, position: 'relative'}}>
                <Mail 
                  size={isMobile ? 18 : 20} 
                  color="#666"
                  style={{ opacity: 0.7 }}
                />
                {getTotalMessages() > 0 && (
                  <div style={{
                    position: 'absolute',
                    top: '-5px',
                    right: '-5px',
                    minWidth: '16px',
                    height: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <ComponentNotificationBulb count={getTotalMessages()} color="#3F749C" />
                  </div>
                )}
              </a>
              <Dropdown 
                className="header-notification-dropdown"
                onToggle={(isOpen) => {
                  console.log('🔔 Dropdown toggled:', isOpen);
                  setDropDownShow(isOpen);
                }}
              >
                <Dropdown.Toggle
                  as={"span"}
                  style={{ maxHeight: "10px", maxWidth: "10px" }}
                />

                <Dropdown.Toggle
                  as={"span"}
                  style={{ maxHeight: "10px", maxWidth: "10px" }}
                >
                  <a onClick={(e) => e.preventDefault()} title="Notifications - Activity Updates" style={{...rsStyles.iconLink, position: 'relative', cursor: 'pointer'}}>
                    <Bell 
                      size={isMobile ? 18 : 20} 
                      color="#666"
                      style={{ opacity: 0.7 }}
                    />
                    {getCurrentNotificationLength() > 0 && (
                      <div 
                        style={{
                          position: 'absolute',
                          top: '-5px',
                          right: '-5px',
                          minWidth: '16px',
                          height: '16px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <ComponentNotificationBulb count={getCurrentNotificationLength()} />
                      </div>
                    )}
                  </a>
                </Dropdown.Toggle>
                <Card>
                  <Dropdown.Menu
                    className="card-box-notify"
                    style={{ 
                      height: "auto", 
                      maxHeight: "500px",
                      width: isMobile ? "280px" : "350px",
                      right: isMobile ? "-40px" : "0"
                    }}
                  >
                    <Container className="d-flex justify-content-center p-1 pb-2 font-weight-500 border-bottom">
                      Notifications
                    </Container>
                    {currentNotification?.length > 0 ? (
                      <InfiniteScroll
                        dataLength={currentNotification?.length}
                        next={fetchMoreNotfctn}
                        hasMore={hasMoreNotfications}
                        loader={
                          <div className="d-flex justify-content-center align-items-center p-3">
                            <ButterflyMark size={24} />
                            <span className="ml-2" style={{ color: "#6c757d", fontSize: "14px" }}>
                              Loading more...
                            </span>
                          </div>
                        }
                        height={isMobile ? 300 : 400}
                        endMessage={
                          <div 
                            className="d-flex flex-column align-items-center justify-content-center p-3"
                            style={{ 
                              color: "#6c757d",
                              fontSize: "14px"
                            }}
                          >
                            <span
                              className="material-icons mb-2"
                              style={{
                                fontSize: "28px",
                                color: "#1DBAAD",
                                opacity: 0.6
                              }}
                            >
                              check_circle
                            </span>
                            <p className="m-0 font-weight-600" style={{ fontSize: "15px", color: "#495057" }}>
                              No more notifications
                            </p>
                            <p className="m-0" style={{ fontSize: "12px", color: "#6c757d", marginTop: "4px" }}>
                              You're all caught up!
                            </p>
                          </div>
                        }
                      >
                        {currentNotification?.filter(notify => notify != null).map((notify, index) => {
                          if (notify?.data?.message) {
                            return (
                              <Dropdown.Item
                                key={Math.random()}
                                eventKey={index}
                                onClick={() => handleOnClickNotification(notify)}
                              >
                                <Notification
                                  key={Math.random()}
                                  nData={notify}
                                  setDropDownShow={setDropDownShow}
                                  dropDownShow={dropDownShow}
                                />
                              </Dropdown.Item>
                            );
                          }
                        })}
                      </InfiniteScroll>
                    ) : (
                      <Dropdown.Item eventKey={0}>
                        No New Notifications
                      </Dropdown.Item>
                    )}
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ 
                        marginTop: "0.5em", 
                        padding: "0.6em 1em",
                        background: "linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%)",
                        borderTop: "1px solid #e0e4e9",
                        borderRadius: "0 0 1rem 1rem"
                      }}
                    >
                      <span
                        className="material-icons"
                        style={{
                          fontSize: isMobile ? "14px" : "16px",
                          color: "#6c757d",
                          marginRight: "0.4em"
                        }}
                      >
                        info
                      </span>
                      <p
                        className="m-0"
                        style={{ 
                          fontSize: isMobile ? "11px" : "12px",
                          color: "#6c757d",
                          fontWeight: "500",
                          letterSpacing: "0.3px"
                        }}
                      >
                        Read notifications auto-clear after 3 days
                      </p>
                    </div>
                  </Dropdown.Menu>
                </Card>
              </Dropdown>
            </>
            )}
            <button
              type="button"
              onClick={openUserNav}
              className={`user-toggle border-0 ${
                !userData?.avatarImg?.slug && "p-2"
              }`}
              style={{
                marginRight: userData?.avatarImg?.slug && (isMobile ? "0.3em" : "0.5em"),
                marginTop: userData?.avatarImg?.slug && (isMobile ? "-0.5em" : "-0.8em"),
                transform: isMobile ? "scale(0.85)" : "scale(1)"
              }}
            >
              <div>
                {userData?.avatarImg?.slug ? (
                  <ComponentAvtar
                    avtrImg={userData?.avatarImg?.url}
                    avtrImgSlug={userData?.avatarImg?.slug}
                    type="avatar"
                    show={false}
                    isCreateCourse={true}
                    isRound={true}
                  />
                ) : (
                  <ComponentAvatar
                    type={"user"}
                    data={{
                      img: BannerImageHandlingForAllDevices(
                        userData?.avatarImg?.url,
                        "user",
                        userData?.avatarImg?.slug
                      ),
                    }}
                  />
                )}
              </div>
            </button>
          </div>
        </header>
      </div>
      <div className="siteheader-buffer"></div>
    </div>
  );
});

export default ComponentSiteheader;
